const activeProjectId = () => {
  var id = localStorage.getItem('activeProjectId') || null;

  return id;
};

export default activeProjectId
